var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcUnselectSettlement(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 21"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 15",
    style: {
      fill: "none"
    },
    d: "M0 0h22v22H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 4"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 9",
    d: "M503.029.665h-12.116a2.963 2.963 0 0 0-2.962 2.958v15.2a2.963 2.963 0 0 0 2.962 2.958h12.116a2.963 2.963 0 0 0 2.962-2.958v-15.2a2.963 2.963 0 0 0-2.962-2.958m-12.116 1.972h12.116a.988.988 0 0 1 .987.986v5.246h-14.09V3.623a.988.988 0 0 1 .987-.986m7.81 17.176h-3.5v-3.5h3.5zm0-5.474h-3.5v-3.5h3.5zm-8.8-3.5h3.319v3.5h-3.319zm0 7.987v-2.514h3.319v3.5h-2.332a.988.988 0 0 1-.987-.986m13.1.986H500.7v-8.971h3.318v7.987a.988.988 0 0 1-.987.986",
    transform: "translate(-485.971 -.226)",
    style: {
      fill: "#00402e"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUnselectSettlement);
export default __webpack_public_path__ + "static/media/ic-unselect-settlement.b6e4bf7a70774092e6b6fbc7089041cc.svg";
export { ForwardRef as ReactComponent };